import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=2b498324&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"
import style0 from "./Step6.vue?vue&type=style&index=0&id=2b498324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b498324",
  null
  
)

export default component.exports